"use strict";
/**
 * @module Services.RemoteServers
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The request of RemoteServers CREATE_REMOTE_SERVER service
 */
var RemoteServerDefinitionImpl = /** @class */ (function () {
    /**
     * Create a new NamedRemoteServerSpecification instance
     *
     * @param name              the remote server name
     * @param url               the remote server url
     * @param principal         the principal used for connection to the remote server
     * @param credentials       the credentials used for connection to the remote server
     * @param connectionOptions the options used for connection to the remote server
     */
    function RemoteServerDefinitionImpl(
    /** The name of the remote server. */
    name, 
    /** The url used for connection to the remote server. */
    url, 
    /** The principal used for connection to the remote server. */
    principal, 
    /** The credentials used for connection to the remote server. */
    credentials, 
    /** Options used for connection to the remote server. */
    connectionOptions, 
    /** The missing topic notification filter. */
    missingTopicNotificationFilter) {
        this.name = name;
        this.url = url;
        this.principal = principal;
        this.credentials = credentials;
        this.connectionOptions = connectionOptions;
        this.missingTopicNotificationFilter = missingTopicNotificationFilter;
    }
    return RemoteServerDefinitionImpl;
}());
exports.RemoteServerDefinitionImpl = RemoteServerDefinitionImpl;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/remote-servers/remote-server-definition.js
// module id = 564
// module chunks = 1